<template>
  <div id="purchaserRegister">
    <div class="content-wrapper">
      <a-form :form="basicInfoForm" v-if="!successRegister">
        <a-form-item
          label="单位名称"
          v-bind="basicInfoItemLayout"
          :required="true"
          :validateStatus="validateStatus.companyName"
          :help="help.companyName"
        >
          <!-- <a-input
            v-decorator="
              'companyName',
              {
                rules: [
                  { required: true, message: '请输入单位名称' },
                  { validator: this.validateCompanyName },
                ],
                validateTrigger: ['blur'],
              },
            ]"
          /> -->
          <SearchSelect
            ref="companySelect"
            :Axios="AbpCompanyGetPaged"
            @input="handelCompanySelected"
            v-decorator="[
              'companyName',
              {
                initialValue: '',
              },
            ]"
          >
            <!-- v-model.trim="form.companyId" -->
            <template slot="notFoundContent"> 请输入公司名称 </template>
          </SearchSelect>
        </a-form-item>
        <a-form-item
          label="信用类型"
          :labelCol="{ span: 9 }"
          :wrapperCol="{ span: 9 }"
        >
          <a-radio-group
            v-model="companyNoType"
          >
            <a-radio value="统一社会信用代码">统一社会信用代码</a-radio>
            <a-radio value="工商注册号">工商注册号</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :label="companyNoType" v-bind="basicInfoItemLayout">
          <a-input
            v-decorator="[
              'companyCode',
              {
                rules: [
                  { required: true, validator: this.validateCompanyCode },
                ],
                validateTrigger: ['blur'],
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          label="机构类型"
          :labelCol="{ span: 9 }"
          :wrapperCol="{ span: 9 }"
        >
          <a-radio-group
            v-decorator="[
              'companyType',
              {
                rules: [{ required: true, message: '请选择机构类型' }],
                initialValue: '政府单位',
              },
            ]"
          >
            <a-radio value="政府单位">政府单位</a-radio>
            <a-radio value="事业单位">事业单位</a-radio>
            <a-radio value="企业单位">企业单位</a-radio>
            <a-radio value="其他组织">其他组织</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="姓名" v-bind="basicInfoItemLayout">
          <a-input
            placeholder="请填写您的真实姓名"
            v-decorator="[
              'name',
              {
                rules: [{ required: true, message: '请输入姓名' }],
                validateTrigger: ['blur'],
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          :required="true"
          label="所属区域"
          v-bind="companyUploaderLayout"
          style="margin-bottom: 0"
        >
          <a-form-item :style="{ display: 'inline-block', width: '180px' }">
            <a-select
              style="width: 170px"
              @change="addressChange"
              v-decorator="[
                'area',
                { rules: [{ required: true, message: '请选择所属区域' }] },
              ]"
            >
              <a-select-option
                v-for="province in address.provinces"
                :value="province.address"
                :key="province.code"
                >{{ province.address }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item
            :style="{
              display: 'inline-block',
              width: '180px',
              marginLeft: '10px',
            }"
          >
            <a-select
              style="width: 160px"
              v-decorator="[
                'area2',
                { rules: [{ required: true, message: '请选择所属区域' }] },
              ]"
            >
              <a-select-option
                v-for="city in address.cities"
                :key="city.code"
                :value="city.address"
                >{{ city.address }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-form-item>
        <a-form-item label="用户名" v-bind="basicInfoItemLayout">
          <a-input
            v-decorator="[
              'userName',
              {
                rules: [{ required: true, validator: this.validateUserName }],
                validateTrigger: ['blur'],
              },
            ]"
            placeholder="请输入登录的用户名"
          />
          <div slot="extra">
            <span style="display: block"
              >以英文字母开头，4-16位字母数字组合；</span
            >
            <span style="white-space: nowrap"
              >请勿包含身份证/银行卡等隐私信息，一旦设置成功无法修改</span
            >
          </div>
        </a-form-item>
        <a-form-item
          label="手机号码"
          v-bind="basicInfoItemLayout"
          class="phone-wrap"
          extra="建议填写业务负责人或管理员手机号码"
        >
          <a-input
            v-decorator="[
              'phoneNumber',
              {
                rules: [
                  { required: true, message: '请输入手机号码' },
                  {
                    pattern: /^1[3456789]\d{9}$/,
                    message: '请输入正确的手机号码',
                  },
                ],
                validateTrigger: ['change', 'blur'],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="验证码" v-bind="basicInfoItemLayout">
          <a-row :gutter="8">
            <a-col :span="17">
              <a-input
                placeholder="验证码"
                v-decorator="[
                  'captchaResponse',
                  {
                    rules: [
                      { required: true, validator: this.validateCaptcha },
                    ],
                    validateTrigger: ['change', 'blur'],
                  },
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="mail"
                  :style="{ color: 'rgba(0,0,0,.25)' }"
                />
              </a-input>
            </a-col>
            <a-col :span="2" class="btn-captcha-wrap">
              <a-button
                class="getCaptcha"
                :disabled="state.smsSendBtn"
                @click.stop.prevent="ShowGraphCertificateModal"
                >{{
                  (!state.smsSendBtn && "获取验证码") || state.time + " s"
                }}</a-button
              >
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="电子邮箱" v-bind="basicInfoItemLayout">
          <a-input
            v-decorator="[
              'emailAddress',
              {
                rules: [
                  {
                    type: 'email',
                    required: true,
                    validator: this.validateEmail,
                  },
                ],
                validateTrigger: ['blur'],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="密码" v-bind="basicInfoItemLayout">
          <a-popover
            placement="rightTop"
            trigger="click"
            :visible="state.passwordLevelChecked"
          >
            <template slot="content">
              <div :style="{ width: '240px' }">
                <div :class="['user-register', passwordLevelClass]">
                  强度：<span>{{ passwordLevelName }}</span>
                </div>
                <a-progress
                  :percent="state.percent"
                  :showInfo="false"
                  :strokeColor="passwordLevelColor"
                />
                <div style="margin-top: 10px">
                  <span>
                    请至少输入
                    8个字符。请不要使用容易被猜到的密码。（需包含数字和字母）
                  </span>
                </div>
              </div>
            </template>
            <a-input
              type="password"
              autocomplete="false"
              placeholder="至少 8 位密码，区分大小写"
              @mouseout="state.passwordLevelChecked = false"
              @mouseover="state.passwordLevelChecked = true"
              v-decorator="[
                'password',
                {
                  rules: [
                    { required: true, message: '至少 8 位密码，区分大小写' },
                    { validator: this.handlePasswordLevel },
                  ],
                  validateTrigger: ['change', 'blur'],
                },
              ]"
            ></a-input>
          </a-popover>
        </a-form-item>
        <a-form-item label="确认密码" v-bind="basicInfoItemLayout">
          <a-input
            type="password"
            autocomplete="false"
            v-decorator="[
              'confirmPass',
              {
                rules: [
                  { required: true, message: '请再次输入密码' },
                  { validator: compareToFirstPassword },
                ],
                validateTrigger: ['change', 'blur'],
              },
            ]"
          />
        </a-form-item>
        <!-- <a-form-item label="是否有客户经理对接" v-bind="basicInfoItemLayout" v-if="this.tenantId === 1">
          <a-radio-group
            v-decorator="['hasManage']"
          >
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false">否</a-radio>
          </a-radio-group>
        </a-form-item> -->
        <!-- <a-form-item label="客户经理姓名" v-bind="basicInfoItemLayout" v-show="basicInfoForm.getFieldValue('hasManage')">
          <a-input
            v-decorator="['custormerManager']"
          />
        </a-form-item> -->
        <!-- <a-form-item style="text-align:center">
          <a-checkbox :checked="readSecret" @change="e => readSecret = e.target.checked">
            <span>
              已阅读并同意
              <a href="javascript:void(0)" @click="secretView = true">《隐私策略》</a>
              <span style="color: #1890ff;">、</span>
              <a href="javascript:void(0)" @click="securityView = true">《账号安全说明》</a>
            </span>
          </a-checkbox>
        </a-form-item> -->
        <a-form-item :wrapper-col="{ span: 12, offset: 11 }">
          <div class="btn-submit-wrap">
            <a-button
              type="primary"
              html-type="submit"
              @click="handleBasicInfoSubmit"
            >
              提交审核
            </a-button>
          </div>
        </a-form-item>
      </a-form>
      <div class="reg-step3-content" v-else>
        <div class="submit-wrap">
          <img src="@/assets/success.png" height="150" width="150" />
          <h1>提交成功</h1>
          <span
            >审核大概需要1个工作日，请耐心等待，可登录账号查看审核状态。</span
          >
        </div>
      </div>
    </div>

    <!-- <a-modal v-model="secretView" :width="1100">
      <iframe frameborder="0" border="0" :src="noticeLink" style="width:1040px;height:600px;overflow:auto;margin-left:15px;margin-top:16px;"></iframe>
      <div slot="footer" >
        <a-button @click="secretView=false" type="primary">关闭</a-button>
      </div>
    </a-modal> -->
    <!-- <a-modal v-model="securityView" :width="1100">
      <iframe frameborder="0" border="0" :src="securityLink" style="width:1040px;height:600px;overflow:auto;margin-left:15px;margin-top:16px;"></iframe>
      <div slot="footer" >
        <a-button @click="securityView=false" type="primary">关闭</a-button>
      </div>
    </a-modal> -->

    <!-- 图形验证弹窗 -->
    <GraphCertificateModal
      ref="GraphCertificateModal"
      :securityUserCenterUrl="securityUserCenterUrl"
      :graphCertificateModalVisible="graphCertificateModalVisible"
      @cancel="graphCertificateModalCancel"
      @ok="graphCertificateModalOk"
    ></GraphCertificateModal>
  </div>
</template>

<script>
import {
  getRegCode,
  validCompany,
  validUser,
  createCompanyInfo,
  // createFile,
  // validCompanyName,
} from "@/api/register";
import { registerBUser, getTenant } from "@/api/platformCenter"; // validBUser
import GraphCertificateModal from "@/components/GraphCertificateModal";
import { trim } from "@/utils/util";
import ChineseDistricts from "@/utils/area"; /* 省市联动 */
import Vue from "vue";
import { REGISTER_TENANT_ID } from "@/store/mutation-types";
import { setWindowGlobalUrl } from "@/utils/axios";
import {
  checkIsNonUserAudit,
  creataUserAuditData,
  getAUserToken,
  getbUserToken,
  getPlatformConfiguration,
} from "@/utils/register";
import { userAuditRecordCreateOrUpdate, AbpCompanyGetPaged } from "@/api/user";
import { getCurrentPlatformSmSConfig } from "@/utils/smsConfig";
import SearchSelect from "@/components/searchSelect";
import { getUserName } from "@/utils/userCenter";

const levelNames = {
  0: "低",
  1: "低",
  2: "中",
  3: "强",
};
const levelClass = {
  0: "error",
  1: "error",
  2: "warning",
  3: "success",
};
const levelColor = {
  0: "#ff0000",
  1: "#ff0000",
  2: "#ff7e05",
  3: "#52c41a",
};

// const fileTips = {
//   gov: "组织机构代码证或三证合一统一社会信用代码证。若无则上传申请公函。若以政府下属部门作为主体申请，需具备自身主体证件；若不具备主体证件，则需以上级机构主体认证。",
//   bus: "营业执照、事业单位法人证书；若是医疗机构提交《医疗机构执业许可证》。若是部队医院提交《军队单位对外有偿服务许可证》 或《有偿收费许可证》或《中国人民解放军部队卫生机构对外非营利性医疗服务许可证》。若以上都没有，请准备组织机构代码证。",
//   com: "营业执照，若无则上传组织机构代码证或三证合一统一社会信用代码证。",
//   else: "组织机构代码证或三证合一统一社会信用代码证。",
// };
export default {
  name: "NormalRegister",
  props: {
    registerRole: String,
  },
  components: {
    GraphCertificateModal,
    SearchSelect,
  },
  data() {
    return {
      // 自定义校验相关
      validateStatus: {
        companyName: "success",
      },
      help: {
        companyName: "",
      },
      registerPlatForm: null, // 注册的平台
      securityUserCenterUrl: null,
      // custormerManager: null, // 客户经理
      agencyName: null, // 入库签约公司
      // noticeLink: 'https://z.choicelink.cn/public/contents/5647/110011.html', // 隐私策略
      // securityLink: 'https://z.choicelink.cn/public/contents/5647/121445.html', // 账号安全说明
      graphCertificateModalVisible: false, // 图形验证弹窗
      // secretView: false,
      // securityView: false,
      // readSecret: false,
      contactVisible: false,
      basicInfoForm: this.$form.createForm(this, { name: "basicInfoForm" }),
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: "#FF0000",
      },
      basicInfoItemLayout: {
        labelCol: {
          span: 9,
        },
        wrapperCol: {
          span: 7,
        },
      },
      companyUploaderLayout: {
        labelCol: {
          span: 9,
        },
        wrapperCol: {
          span: 12,
        },
      },
      successRegister: false,
      address: {
        provinces: ChineseDistricts["86"],
        cities: [],
      },
      companySelected: {},
      companyNoType: '统一社会信用代码',
    };
  },
  computed: {
    tenantId() {
      let tenantId = null;
      switch (this.registerRole) {
        case "采购人":
          tenantId = 1;
          break;
        case "供应商":
          tenantId = 2;
          break;
        case "代理机构":
          tenantId = 3;
          break;
        default:
          tenantId = 1;
          break;
      }
      return tenantId;
    },
    passwordLevelClass() {
      return levelClass[this.state.passwordLevel];
    },
    passwordLevelName() {
      return levelNames[this.state.passwordLevel];
    },
    passwordLevelColor() {
      return levelColor[this.state.passwordLevel];
    },
  },
  async mounted() {
    this.registerPlatForm = await this.getPlatformTenancyName(
      await this.getQueryVariable("tenantId")
    );
    if (
      window.urlConfig &&
      window.urlConfig.requests &&
      window.urlConfig.requests.middlewareUrl
    ) {
      this.securityUserCenterUrl =
        window.urlConfig.requests.middlewareUrl + "/security/userCenter";
    } else {
      await setWindowGlobalUrl();
      this.securityUserCenterUrl =
        window.urlConfig.requests.middlewareUrl + "/security/userCenter";
    }
  },
  methods: {
    AbpCompanyGetPaged,
    async getQueryVariable(variable) {
      const query = window.location.search.substring(1);
      const vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0].toLocaleLowerCase() === variable.toLocaleLowerCase()) {
          return decodeURIComponent(pair[1]);
        }
      }
      // 没有平台数据传递时默认注册云采链
      if (Vue.ls.get(REGISTER_TENANT_ID)) {
        return Vue.ls.get(REGISTER_TENANT_ID);
      } else {
        await setWindowGlobalUrl();
        return Vue.ls.get(REGISTER_TENANT_ID);
      }
    },
    graphCertificateModalCancel() {
      this.graphCertificateModalVisible = false;
    },
    graphCertificateModalOk(graphCode) {
      this.getCaptcha(graphCode);
    },
    // 显示图形验证弹窗
    ShowGraphCertificateModal() {
      this.basicInfoForm.validateFields(
        ["phoneNumber"],
        { force: true },
        async (err, values) => {
          // console.log(err)
          if (!err) {
            this.graphCertificateModalVisible = true;
            this.$nextTick(() => {
              // console.log(this.$refs.GraphCertificateModal)
              this.$refs.GraphCertificateModal.setPhoneNumber(
                values.phoneNumber
              );
            });
          } else {
            this.$message.error("请按要求填写手机号码");
          }
        }
      );
    },
    // 校验单位名称
    async validateCompanyName(rule, value, callback) {
      console.log("validateCompanyName", this.$refs.companySelect.selectValue);
      if (!value) {
        console.log(
          "validateCompanyName",
          this.$refs.companySelect.selectValue
        );
        callback(new Error("请输入单位名称"));
      }
      // TODO
      /**
       * 修改检查接口
       * （检查当前公司在当前平台是否有BUser的账号-非删除的）
       *  */
      // const validRep = await validCompanyName(trim(value, true));
      // if (validRep.result) {
      //   callback(new Error("该单位名称已注册"));
      // }
    },
    // 校验统一社会信用代码
    async validateCompanyCode(rule, value, callback) {
      if (value === null || value === '' || value.length === 0) {
        callback(new Error(`请输入${this.companyNoType}`))
        return
      }
      if (/[\u4e00-\u9fa5]/.test(value)) {
        callback(new Error("检测到输入了中文，请检查是否填写有误"));
        return;
      }
      if (/[a-z]/.test(value)) {
        callback(new Error("请输入大写字母"));
        return;
      }
      if (this.companyNoType === '统一社会信用代码' && value.length !== 18) {
        callback(new Error("请输入18位的统一社会信用代码"));
        return;
      }
      callback();
      // TODO
      /**
       * 修改检查接口
       * （检查当前公司在当前平台是否有BUser的账号-非删除的）
       *  */
      // const validRep = await validCompany(trim(value, true));
      // if (validRep.result) {
      //   callback(new Error("该单位已存在"));
      // }
    },
    // 校验验证码
    async validateCaptcha(rule, value, callback) {
      if (value === null || value === "" || value.length === 0) {
        callback(new Error("请输入验证码"));
      } else if (!/^\d{6}$/.test(value)) {
        callback(new Error("请输入6位数字验证码"));
      } else {
        callback();
      }
    },
    // 校验邮箱 (注：该接口如果存在会直接500报错)
    async validateEmail(rule, value, callback) {
      if (value === null || value === "" || value.length === 0) {
        callback(new Error("请输入邮箱地址"));
      } else if (
        !/^([a-zA-Z\d][\w-]{2,})@(\w{2,})\.([a-z]{2,})(\.[a-z]{2,})?$/.test(
          value
        )
      ) {
        callback(new Error("请输入正确的邮箱地址"));
      } else {
        // const validRep = await validUser(trim(value, true));
        // if (!validRep.success) {
        //   callback(new Error(validRep.error.message));
        // } else {
        callback();
        // }
      }
    },
    // 校验用户名(注：该接口如果存在会直接500报错)
    async validateUserName(rule, value, callback) {
      if (value === null || value === "" || value.length === 0) {
        callback(new Error("请输入用户名"));
      } else if (!/^[a-zA-Z][a-zA-Z0-9]{3,15}$/.test(value)) {
        callback(new Error("不符合的格式（可包含字母、数字）"));
      } else {
        const validRep = await validUser(trim(this.getUserName(value), true));
        if (!validRep.success) {
          callback(new Error(validRep.error.message));
        } else {
          callback();
        }
      }
    },
    // 所选区域发生变化时触发的函数-单位名称-获取下一级区域的数据
    addressChange(value, option) {
      this.address.cities = [];
      this.basicInfoForm.setFieldsValue({ area2: undefined });
      const options = ChineseDistricts[option.key];
      Object.keys(options).forEach((key) => {
        this.address.cities.push({
          code: key,
          address: options[key],
        });
      });
    },
    // 提交审核
    handleBasicInfoSubmit(e) {
      e.preventDefault();
      // console.log('registerPlatForm', this.registerPlatForm, 'REGISTER_TENANT_ID', Vue.ls.get(REGISTER_TENANT_ID))
      this.basicInfoForm.validateFields(async (err, values) => {
        console.log("handleBasicInfoSubmit", err, values);
        console.log("handleBasicInfoSubmit", this.companySelected);
        if (!err) {
          // // 隐私策略
          // if (!this.readSecret) {
          //   this.$message.info('请先阅读并同意《隐私策略》')
          //   return
          // }
          try {
            this.$spin.show("正在注册账号，请稍候...");
            // 注册账号
            const bTenantId = Vue.ls.get(REGISTER_TENANT_ID);
            let parameter = {
              name: "",
              surname: values.name,
              userName: "",
              emailAddress: "",
              password: "",
              phoneNumber: "",
              captchaResponse: "",
              isActive: true,
              custormerManager: "",
              department: "",
              registerEntry: bTenantId,
              companyInput: {
                companyName: trim(values.companyName, true),
                companyNo: trim(values.companyCode, true),
                companyNoType: this.companyNoType,
                companyTel: "/",
                companyType: values.companyType,
                area: values.area,
                area2: values.area2,
              },
            };
            parameter = Object.assign(parameter, values);
            // 特殊处理userName
            parameter.userName = this.getUserName(parameter.userName);
            const { result, success, error } = await createCompanyInfo(
              parameter,
              this.tenantId
            ); // 采购人请求头租户id传1
            if (!success) {
              this.$message.error(`注册失败：${error.message}`);
              return;
            }
            let companyId = result?.companyId;
            if (!companyId || companyId.indexOf("00000000") > -1) {
              const validRep = await validCompany(
                trim(values.companyCode, true)
              );
              companyId = validRep.result;
            }
            // b账户：采购人入库
            const {
              result: bUser,
              success: bUserSuc,
              error: bUserErr,
            } = await this.platformUserRegister(result, parameter);
            if (!bUserSuc) {
              this.$message.error(`注册失败：${bUserErr.message}`);
              return;
            }
            // if (values['upload-business-license']) {
            //   await this.createBusinessLicenseFile(companyId, values['upload-business-license'].file.response.result)
            // }

            /**
             * 添加userAudit数据
             * 1. 获取token
             * 2. 获取当前注册平台的平台设置数据
             * 3. 判断判断是否免审入库：是：创建userAudit为审核通过的数据；否：没有操作
             * 4. 添加入库审核记录表
             */
            const { A_ACCESS_TOKEN } = await getAUserToken(
              this.getUserName(values.userName),
              values.password,
              this.tenantId
            );
            const { ACCESS_TOKEN } = await getbUserToken(
              this.tenantId,
              bUser.tenantId,
              result.msg,
              A_ACCESS_TOKEN
            );
            const platformConfiguration = await getPlatformConfiguration(
              bUser.tenantId,
              {
                "Abp.TenantId": bUser.tenantId,
                Authorization: `Bearer ${ACCESS_TOKEN}`,
              }
            );
            if (!platformConfiguration) {
              this.$message.warning("获取配置信息失败");
              return false;
            }
            // 如果不需要审核入库，创建审核通过的数据
            let status = "";
            let comment = "";
            if (checkIsNonUserAudit(platformConfiguration)) {
              status = "2"; // 通过
              comment = "免审入库通过"; // 通过
            } else {
              status = "0"; // 待审核
            }
            const registerInfo = {
              companyId: result.companyId,
              companyName: trim(values.companyName, true),
              name: values.name,
              provider: this.tenantId, // aTenantId
              providerKey: result.msg, // aUserId
              tenantId: bUser.tenantId,
              userId: bUser.id,
              userName: values.userName,
            };
            await creataUserAuditData(registerInfo, status, {
              "Abp.TenantId": bUser.tenantId,
              Authorization: `Bearer ${ACCESS_TOKEN}`,
            });
            // 添加审核记录表
            const userAuditRecordParams = {
              type: "供应商入库",
              providerKey: result.msg,
              tenantId: bUser.tenantId,
              companyId: result.companyId,
              comment,
              status,
            };
            await userAuditRecordCreateOrUpdate(userAuditRecordParams, {
              "Abp.TenantId": this.tenantId,
              Authorization: `Bearer ${A_ACCESS_TOKEN}`,
            });

            this.successRegister = true;
          } catch (err) {
            console.log(err);
            const errResult = err.response.data.error.message;
            if (errResult === "用户名已存在!") {
              this.$info({
                title: "用户名已存在",
                content: "用户名已存在，请使用其他用户名称",
                okText: "确定",
              });
              return;
            }
            this.$message.error(`注册失败：${errResult}`);
          } finally {
            this.$spin.hide();
          }
        }
      });
    },
    // 密码安全等级处理
    handlePasswordLevel(rule, value, callback) {
      let level = 0;

      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++;
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++;
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++;
      }
      this.state.passwordLevel = level;
      this.state.percent = level * 30;
      if (value.length < 8) {
        callback(new Error("密码长度不够"));
      } else {
        if (level >= 2) {
          if (level >= 3) {
            this.state.percent = 100;
          }
          callback();
        } else {
          if (level === 0) {
            this.state.percent = 10;
          }
          callback(new Error("密码强度不够"));
        }
      }
    },
    // 确认密码 与 密码 校验是否一致
    compareToFirstPassword(rule, value, callback) {
      const form = this.basicInfoForm;
      if (value && value !== form.getFieldValue("password")) {
        callback(new Error("密码不一致!"));
      } else {
        callback();
      }
    },
    // 获取验证码
    getCaptcha(graphCode) {
      const {
        basicInfoForm: { validateFields },
        state,
        $notification,
        $message,
      } = this;
      validateFields(["phoneNumber"], { force: true }, async (err, values) => {
        if (!err) {
          if (!graphCode) {
            this.$message.error("请先获取图形验证码");
            return;
          }
          const hide = $message.loading("验证码发送中...", 0);
          // 获取当前平台的短息网配置
          let currentPlatformSmSConfig = null
          let getSettingError = false
          try {
            currentPlatformSmSConfig = await getCurrentPlatformSmSConfig(
              Vue.ls.get(REGISTER_TENANT_ID)
            );
          } catch (error) {
            console.error(error);
            getSettingError = true
          }
          if (getSettingError) {
            this.$message.error('短信配置有误，发送失败')
            return
          }
          const parameter = {
            captcha: graphCode,
            phoneNumber: this.basicInfoForm.getFieldValue("phoneNumber"),
            action: "Register",
            signId: currentPlatformSmSConfig.signId, // 发送短信的签名Id
            smsConfigName: currentPlatformSmSConfig.smsConfigName, // 短信网的配置name
            templateId: currentPlatformSmSConfig.templateId, // 短信网的模板Id
          };
          let interval = null;
          try {
            let res = await getRegCode(parameter);
            // console.log(res)
            if (res.success) {
              res = res.result;
              if (res.result.message === "SUCCESS") {
                setTimeout(hide, 1000);
                $notification.success({
                  message: "提示",
                  description: "验证码已发送，请及时查看",
                  duration: 4,
                });
                state.smsSendBtn = true;
                interval = window.setInterval(() => {
                  if (state.time-- <= 0) {
                    state.time = 60;
                    state.smsSendBtn = false;
                    window.clearInterval(interval);
                  }
                }, 1000);
                this.graphCertificateModalVisible = false;
              } else {
                // console.log(res.result)
                this.$message.error(res.result.message);
              }
            } else {
              this.$message.error(res.error.message);
            }
            setTimeout(hide, 1);
          } catch (e) {
            setTimeout(hide, 1);
            clearInterval(interval);
            state.time = 60;
            state.smsSendBtn = false;
            this.$notification.error({
              message: "错误",
              description: "图形验证码错误",
              duration: 4,
            });
            this.registerBtn = false;
          }
        }
      });
    },
    // // 创建营业执照文件
    // async createBusinessLicenseFile(companyId, file) {
    //   await createFile({
    //     companyId: companyId,
    //     typeName: "资质文件",
    //     fileName: file.displayName,
    //     fileId: file.id,
    //     fileUrl: "",
    //   });
    // },
    async getPlatformTenancyName(tenantId) {
      const { result } = await getTenant({ filter: `id == "${tenantId}"` });
      this.$message.success(
        `您现在正在注册成为 ${result?.items[0].name} ${this.registerRole}`
      );
      return result?.items[0].tenancyName || null;
    },
    // 注册平台账户 采购人入库平台
    async platformUserRegister(aUser, parameter) {
      // const auditRole = this.registerRole === '采购人' ? '审核人' : this.registerRole
      const params = {
        // active: false,
        tenancyName: "" + this.registerPlatForm,
        roleName: this.registerRole,
        needAudit: false,
        userInfo: {
          companyId: aUser.companyId,
          companyName: parameter.companyInput.companyName,
          emailAddress: parameter.emailAddress,
          name: parameter.name,
          phoneNumber: parameter.phoneNumber,
          provider: "" + this.tenantId,
          providerKey: "" + aUser.msg,
          surname: parameter.name,
          userName: parameter.userName,
        },
      };
      // 采购人注册
      return await registerBUser(params);
    },
    // 加载客户经理列表
    // async loadManager (e) {
    //   this.custormerManager = undefined
    //   if (this.agencyName) {
    //     this.$spin.show()
    //     const rep = await GetManagerPaged({
    //       filter: `agencyName == "${this.agencyName}"`,
    //       MaxResultCount: 500
    //     })
    //     this.manageList = rep.result.items
    //     if (this.companyService.id) this.custormerManager = this.companyService.managerName
    //     const agencyId = this.companyList.filter(item => item.itemName === this.agencyName)[0].itemCode
    //     const rep1 = await GetAgencyUserListByRole({
    //       RoleName: '运营人员',
    //       CompanyId: agencyId
    //     })
    //     this.operatorList = rep1.result.items
    //     if (this.companyService.id) this.operator = this.companyService.operateName
    //     this.$spin.hide()
    //   }
    // },
    /**
     * 获取实际注册的userName
     * （给每个账号加上tenantId标识）
     */
    getUserName,
    /**
     * 选中公司
     */
    handelCompanySelected(val) {
      console.log(val);
      this.companySelected = { ...val };
      if (val.companyInfo) {
        this.basicInfoForm.setFieldsValue({
          companyCode: val.companyInfo.companyNo,
        });
      }
      console.log(val.companyName);
      this.basicInfoForm.setFieldsValue({
        companyName: val.companyName,
      });
      if (!val.companyName) {
        this.validateStatus.companyName = "error";
        this.help.companyName = "请输入公司名称";
      } else {
        this.validateStatus.companyName = "success";
        this.help.companyName = "";
      }
    },
  },
  filters: {
    // filterTip(val) {
    //   let result = fileTips.gov;
    //   switch (val) {
    //     case "政府单位":
    //       result = fileTips.gov;
    //       break;
    //     case "事业单位":
    //       result = fileTips.bus;
    //       break;
    //     case "企业单位":
    //       result = fileTips.com;
    //       break;
    //     case "其他组织":
    //       result = fileTips.else;
    //       break;
    //   }
    //   return result;
    // },
  },
};
</script>

<style lang="less">
.content-wrapper {
  width: 1200px;
  min-height: 800px;
  background: #fff;
  margin: 0 auto;
  padding: 50px 0;
  box-shadow: 0 2px 15px 0 rgba(190, 207, 228, 0.3);
}
#purchaserRegister {
  // padding: 40px 0 85px 0;
  padding-bottom: 40px;
  background: #f7f7f8;
  padding-top: 40px;
  .suggestion-wrap {
    line-height: 20px;
    margin-top: 4px;
  }
  .reg-step3-content {
    .submit-wrap {
      font-family: PingFangSC-Regular;
      text-align: center;
      margin-top: 120px;
      font-size: 14px;

      h1 {
        font-weight: bold;
        font-size: 20px;
        line-height: 28px;
        margin: 0;
      }

      a {
        font-size: 14px;
      }

      span {
        line-height: 36px;
        color: #333;
      }
    }
  }
  .role-item {
    img {
      width: 80px;
      height: 80px;
    }
    h2 {
      display: inline-block;
      color: #048df2;
      font-weight: bolder;
      font-size: 28px;
      vertical-align: -webkit-baseline-middle;
      margin-left: -5px;
    }
  }
  .content-container {
    width: calc(100% - 40px);
    min-height: 100px;
    background: #ecf8ff;
    padding: 20px 25px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    margin: 0 20px;
    h2 {
      font-size: 17px;
      font-weight: bold;
      color: #048df2;
    }
    h3 {
      color: #86a1b5;
      font-size: 14px;
    }
  }
}
.getCaptcha {
  transform: translateY(-1px);
}
</style>
